import { Button } from '@platform/ui-kit'
import { m, LazyMotion, domAnimation } from 'framer-motion'
import { forwardRef, useMemo } from 'react'

import {
  LogoAndreessen,
  LogoBa,
  LogoFj,
  LogoGradientVentures,
  LogoSilicon,
  LogoSomaCapital,
  LogoYCombinator,
  LogoSoftBank,
} from '../../../assets/icons'

import styles from './styles.module.scss'

const MARQUEE_VARIANTS = {
  animate: {
    x: ['0%', '-100%'],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 30,
        ease: 'linear',
      },
    },
  },
}

const MARQUEE_VARIANTS_TWO = {
  animate: {
    x: ['100%', '0%'],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 30,
        ease: 'linear',
      },
    },
  },
}

export const OurClientsAreFundedBy = forwardRef<HTMLElement>((_, ref) => {
  const logos = useMemo(
    () => (
      <>
        <LogoAndreessen className={styles['icon']} />
        <LogoBa className={styles['icon']} />
        <LogoFj className={styles['icon']} />
        <LogoGradientVentures className={styles['icon']} />
        <LogoSilicon className={styles['icon']} />
        <LogoSomaCapital className={styles['icon']} />
        <LogoYCombinator className={styles['icon']} />
        <LogoSoftBank className={styles['icon']} />
      </>
    ),
    []
  )

  return (
    <section className={styles['container']} ref={ref}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          Our clients are <span className={styles['funded']}>backed</span> by
        </h2>
        <div className={styles['logos-container']}>
          <LazyMotion features={domAnimation} strict>
            <m.div className={styles['track']} variants={MARQUEE_VARIANTS} animate="animate">
              {logos}
            </m.div>
            <m.div className={styles['track']} variants={MARQUEE_VARIANTS_TWO} animate="animate">
              {logos}
            </m.div>
          </LazyMotion>
        </div>
        <Button variant="default" size="large" className={styles['button']} href="/companies">
          Hire Olby
        </Button>
      </div>
    </section>
  )
})

export default OurClientsAreFundedBy
